import type { PoAssignmentInput } from '@/services/capacityCalendarService';
import { ASSIGNMENT_TYPE, RESERVATION_LABEL } from '@/types/capacityCalendar';

const SINGLE = 1;

function formatWeekStart(weekKey: string): string {
  const [year, month, day] = weekKey.split('-').map(Number);
  return new Date(year, month - SINGLE, day).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

// One write can carry purchase orders, reservations, or both, so the toast names what
// actually landed rather than claiming "purchase order" for a maintenance reservation.
export function assignmentSuccessMessage(assignments: PoAssignmentInput[]): string {
  const manualCount = assignments.filter((assignment) => assignment.type === ASSIGNMENT_TYPE.manual).length;
  const poAssignments = assignments.filter((assignment) => assignment.type !== ASSIGNMENT_TYPE.manual);

  if (manualCount === assignments.length) {
    return manualCount === SINGLE ? `${RESERVATION_LABEL} added` : `${manualCount} reservations added`;
  }
  if (manualCount > 0) {
    return `${assignments.length} assignments scheduled`;
  }
  const [first] = poAssignments;
  return poAssignments.length === SINGLE && first.poNumber ? `${first.poNumber} scheduled` : `${poAssignments.length} purchase orders scheduled`;
}

// A null poNumber is a reservation distributed across the week's capacity types.
export function distributionSuccessMessage(poNumber: string | null, portionCount: number): string {
  const subject = poNumber ?? RESERVATION_LABEL;
  return portionCount === SINGLE ? `${subject} scheduled` : `${subject} scheduled across ${portionCount} capacity types`;
}

export function quantityUpdateMessage(quantity: number): string {
  return `Quantity updated to ${quantity.toLocaleString()}`;
}

export function noteUpdateMessage(notes: string): string {
  return notes.trim() ? 'Note saved' : 'Note removed';
}

export function moveSuccessMessage(targetWeekStart: string): string {
  return `Moved to the week of ${formatWeekStart(targetWeekStart)}`;
}
